<template>
	<div data-tour-scope="order-suppliers">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<template>
						<v-row class="fill-height">
							<v-col>
								<v-sheet height="64">
									<v-toolbar flat>
										<v-btn outlined data-tour="nav" class="mr-4" color="grey darken-2" @click="setToday"> Today </v-btn>
										<v-btn fab text small color="grey darken-2" @click="prev">
											<v-icon small> mdi-chevron-left </v-icon>
										</v-btn>
										<v-btn fab text small color="grey darken-2" @click="next">
											<v-icon small> mdi-chevron-right </v-icon>
										</v-btn>
										<v-toolbar-title v-if="$refs.calendar">
											{{ $refs.calendar.title }}
										</v-toolbar-title>
										<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
										<v-icon left>mdi-school-outline</v-icon>
										Tutorial guidato
									</v-btn>
										<v-spacer />
										<v-menu bottom right>
											<template #activator="{ on, attrs }">
												<v-btn outlined data-tour="view" color="grey darken-2" v-bind="attrs" v-on="on">
													<span>{{ typeToLabel[type] }}</span>
													<v-icon right> mdi-menu-down </v-icon>
												</v-btn>
											</template>
											<v-list>
												<v-list-item @click="type = 'day'">
													<v-list-item-title>Day</v-list-item-title>
												</v-list-item>
												<v-list-item @click="type = 'week'">
													<v-list-item-title>Week</v-list-item-title>
												</v-list-item>
												<v-list-item @click="type = 'month'">
													<v-list-item-title>Month</v-list-item-title>
												</v-list-item>
												<v-list-item @click="type = '4day'">
													<v-list-item-title>4 days</v-list-item-title>
												</v-list-item>
											</v-list>
										</v-menu>
									</v-toolbar>
								</v-sheet>
								<v-sheet height="600">
									<v-calendar
										ref="calendar"
										data-tour="calendar"
										v-model="focus"
										color="primary"
										:events="events"
										:event-color="getEventColor"
										:type="type"
										@click:event="showEvent"
										@click:more="viewDay"
										@click:date="viewDay"
										@change="updateRange"
									>
										<template #day-label="{ date, day, present }">
											<div style="display: inline-flex; align-items: center; justify-content: center; cursor: pointer; padding: 2px 4px" @click.stop="viewDay({ date })">
												<span class="text-caption font-weight-bold" :class="present ? 'primary--text' : ''">{{ day }}</span>
												<v-icon v-if="hasDateEvents(date)" x-small color="teal darken-1" class="ml-1"> mdi-printer </v-icon>
											</div>
										</template>
									</v-calendar>
								</v-sheet>
							</v-col>
						</v-row>
					</template>
				</v-layout>
			</v-container>
		</v-main>

		<v-row v-if="dialog" justify="center">
			<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
				<v-card data-tour-scope="order-supplier-detail">
					<v-toolbar dark color="primary">
						<v-btn icon dark @click="dialog = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
						<v-toolbar-title>{{ selectedEvent.name }}</v-toolbar-title>
						<v-btn class="ml-6" outlined color="white" data-tour="tutorial" @click="detailTour.start()">
							<v-icon left>mdi-school-outline</v-icon>
							Tutorial guidato
						</v-btn>
						<v-spacer />
						<v-toolbar-items>
							<v-btn dark text @click="dialog = false"> Chiudi </v-btn>
						</v-toolbar-items>
					</v-toolbar>
					<v-list three-line subheader>
						<v-subheader
							>Totale ordini per il giorno {{ new Date(selectedEvent.start).toLocaleDateString() }}: <span class="font-weight-bold ml-3">{{ selectedEvent.count }}</span></v-subheader
						>
						<!-- telefono: ogni prodotto diventa una card chiave/valore -->
						<div v-if="mobileCards" data-tour="summary" class="kv-list supplier-order-cards px-3 pb-2">
							<key-value-card
								v-for="(product, index) in selectedEvent.details.products"
								:key="index"
								:title="product.Title || 'Prodotto'"
								:fields="campiProdottoEvento(product)"
							>
								<div class="d-flex align-center justify-space-between">
									<span class="card-label">Escludi prodotto</span>
									<v-checkbox
										v-model="product.exclude"
										data-tour="exclude"
										color="red"
										hide-details
										class="mt-0 pt-0"
										@change="updateExclude(selectedEvent.details.order_id, product.ItemID, product.exclude)"
									/>
								</div>
								<v-btn class="mt-2" block data-tour="rollback" color="red" dark small @click="rollbackOrder(product.OrderID)"> ANNULLA PREPARAZIONE </v-btn>
							</key-value-card>
							<div v-if="!(selectedEvent.details.products || []).length" class="grey--text text-center py-4">Nessun elemento</div>
						</div>
						<v-simple-table v-else data-tour="summary" class="mb-2 pl-2 pr-2" style="max-height: 900px; overflow-y: auto">
							<thead>
								<tr>
									<th class="text-left" width="10%">Escludi Prodotto</th>
									<th class="text-left" width="10%">N° Ordine Fornitore</th>
									<th class="text-left" width="50%">Nome Prodotto</th>
									<th class="text-left" width="10%">Quantità</th>
									<th class="text-left" width="10%">Rif.Ordine</th>
									<th class="text-left" width="10%">Annulla Preparazione</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="product in selectedEvent.details.products">
									<td class="text-left">
										<v-checkbox
											v-model="product.exclude"
											data-tour="exclude"
											color="red"
											hide-details
											style="margin-top: 0; justify-content: left"
											@change="updateExclude(selectedEvent.details.order_id, product.ItemID, product.exclude)"
										/>
									</td>
									<td>{{ selectedEvent.details.order_id }}</td>
									<td>{{ product.Title }} - SKU: {{ product.SKU }}</td>
									<td>{{ product.QuantityPurchased }}</td>
									<td>{{ product.OrderID }}</td>
									<td>
										<v-btn class="ma-2" data-tour="rollback" color="red" dark small @click="rollbackOrder(product.OrderID)"> ANNULLA </v-btn>
									</td>
								</tr>
							</tbody>
						</v-simple-table>
					</v-list>
					<v-divider class="mt-2 mb-2" />
					<v-list three-line subheader>
						<div class="pa-4 text-right">
							<v-btn color="primary" data-tour="download" @click="downloadCsv(selectedEvent)"> <v-icon dark class="mr-2"> mdi-cloud-download </v-icon> SCARICA RIEPILOGO </v-btn>

							<v-btn color="primary" data-tour="mail" class="ml-2" :loading="loading_mail" @click="sendMail(selectedEvent)">
								<v-icon v-if="!loading_mail" dark class="mr-2"> mdi-email-send-outline </v-icon>
								INVIA TRAMITE MAIL
								<template #loader>
									<span class="custom-loader">
										<v-icon dark>cached</v-icon>
									</span>
								</template>
							</v-btn>
						</div>
					</v-list>

					<!-- Ultimo elemento, e dentro la card: la finestra si chiude al primo click
               fuori, quindi il suo tutorial deve vivere qui dentro. -->
					<TourOverlay :tour="detailTour"></TourOverlay>
				</v-card>

				<v-dialog v-model="dialogConfirmRollback" persistent max-width="290">
					<v-card>
						<v-card-title class="headline"> Sei sicuro? </v-card-title>
						<v-card-text> Cliccando su conferma verranno eliminati tutti gli ordini in lavorazione relativi all'ordine cliente n° {{ orderIdRollback }} </v-card-text>

						<v-card-actions>
							<v-spacer />

							<v-btn
								color="primary"
								text
								@click="
									dialogConfirmRollback = false;
									orderIdRollback = '';
								"
							>
								Annulla
							</v-btn>

							<v-btn color="primary" text @click="executeRollbackOrder"> Conferma </v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
					{{ snackbar.text }}
					<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
				</v-snackbar>
			</v-dialog>
		</v-row>

		<v-row v-if="dialogDay" justify="center">
			<v-dialog v-model="dialogDay" fullscreen hide-overlay transition="dialog-bottom-transition">
				<v-card>
					<v-toolbar dark color="teal darken-2">
						<v-btn icon dark @click="dialogDay = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
						<v-toolbar-title> Riepilogo giorno {{ new Date(selectedDayDate + 'T00:00:00').toLocaleDateString() }} </v-toolbar-title>
						<v-spacer />
						<v-toolbar-items>
							<v-btn dark text @click="dialogDay = false"> Chiudi </v-btn>
						</v-toolbar-items>
					</v-toolbar>
					<v-list three-line subheader>
						<v-subheader>
							Totale prodotti: <span class="font-weight-bold ml-3">{{ selectedDayProducts.length }}</span> &nbsp;|&nbsp; Fornitori:
							<span class="font-weight-bold ml-1">{{ selectedDayEvents.length }}</span>
						</v-subheader>
						<!-- telefono: ogni prodotto del giorno diventa una card chiave/valore -->
						<div v-if="mobileCards" class="kv-list supplier-order-cards px-3 pb-2">
							<key-value-card v-for="(product, idx) in selectedDayProducts" :key="idx" :title="product.supplierName" :fields="campiProdottoGiorno(product)"></key-value-card>
							<div v-if="!selectedDayProducts.length" class="grey--text text-center py-4">Nessun elemento</div>
						</div>
						<v-simple-table v-else class="mb-2 pl-2 pr-2" style="max-height: 900px; overflow-y: auto">
							<thead>
								<tr>
									<th class="text-left" style="width: 20%">Fornitore</th>
									<th class="text-left" style="width: 10%">N° Ordine Fornitore</th>
									<th class="text-left" style="width: 40%">Nome Prodotto</th>
									<th class="text-left" style="width: 10%">Quantità</th>
									<th class="text-left" style="width: 10%">Rif.Ordine</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(product, idx) in selectedDayProducts" :key="idx">
									<td>{{ product.supplierName }}</td>
									<td>{{ product.orderSupplierId }}</td>
									<td>{{ product.Title }} - SKU: {{ product.SKU }}</td>
									<td>{{ product.QuantityPurchased }}</td>
									<td>{{ product.OrderID }}</td>
								</tr>
							</tbody>
						</v-simple-table>
					</v-list>
					<v-divider class="mt-2 mb-2" />
					<div class="pa-4 text-right">
						<v-btn color="primary" @click="downloadCsvAll">
							<v-icon dark class="mr-2"> mdi-cloud-download </v-icon>
							SCARICA RIEPILOGO
						</v-btn>
						<v-btn color="success" class="ml-2" @click="downloadExcelAll">
							<v-icon dark class="mr-2"> mdi-file-excel </v-icon>
							SCARICA EXCEL
						</v-btn>
						<v-btn color="primary" class="ml-2" :loading="loading_mail_all" @click="sendMailAll">
							<v-icon v-if="!loading_mail_all" dark class="mr-2"> mdi-email-send-outline </v-icon>
							INVIA TRAMITE MAIL
							<template #loader>
								<span class="custom-loader">
									<v-icon dark>cached</v-icon>
								</span>
							</template>
						</v-btn>
					</div>
				</v-card>
			</v-dialog>
		</v-row>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import * as XLSX from 'xlsx';

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createOrderSuppliersTourSteps } from './order-suppliers-tour';
import { createOrderSupplierDetailTourSteps } from './order-supplier-detail-tour';

export default {
	name: 'OrderSuppliers',
	components: { TourOverlay, KeyValueCard },
	/*
	 * Due giri distinti: il calendario e la finestra del fornitore. Servono due
	 * overlay perche la finestra si chiude al primo click fuori, quindi il suo
	 * tutorial deve stare dentro di lei.
	 *
	 * Nascono in `setup()` e non in `data()`: quello che sta in `data()` viene reso
	 * reattivo in profondita da Vue 2, e in quel passaggio i `ref` del motore
	 * verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createOrderSuppliersTourSteps()),
			detailTour: useTour(createOrderSupplierDetailTourSteps()),
		};
	},
	beforeDestroy() {
		this.tour.stop();
		this.detailTour.stop();
	},
	data: () => ({
		snackbar: {
			snackbar: false,
			color: '',
			mode: '',
			timeout: 6000,
			text: '',
		},
		loading_mail: false,
		loading_mail_all: false,
		dialog: false,
		dialogDay: false,
		selectedDayDate: '',
		selectedDayEvents: [],
		focus: '',
		type: 'month',
		typeToLabel: {
			month: 'Month',
			week: 'Week',
			day: 'Day',
			'4day': '4 Days',
		},
		selectedEvent: {},
		selectedElement: null,
		selectedOpen: false,
		events: [],
		colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
		dialogConfirmRollback: false,
		orderIdRollback: '',
		ordersVoid: [],
	}),
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		selectedDayProducts() {
			return this.selectedDayEvents.flatMap(event =>
				event.details.products.map(p => ({
					...p,
					supplierName: event.details.supplier.Company,
					orderSupplierId: event.details.order_id,
					_event: event,
				})),
			);
		},
	},
	mounted() {
		this.$refs.calendar.checkChange();
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
		}),
		...mapActions({
			getSupplierOrders: 'orders/getSupplierOrders',
			sendSupplierOrdersEmail: 'orders/sendSupplierOrdersEmail',
			excludeProductFromOrder: 'orders/excludeProductFromOrder',
			rollbackSuppliersOrder: 'orders/rollbackSuppliersOrder',
		}),
		// coppie chiave/valore della card prodotto nel dettaglio fornitore (vista telefono)
		campiProdottoEvento(product) {
			return [
				{ label: 'SKU', value: product.SKU },
				{ label: 'N° Ordine Fornitore', value: this.selectedEvent.details.order_id },
				{ label: 'Quantità', value: product.QuantityPurchased, strong: true },
				{ label: 'Rif. Ordine', value: product.OrderID },
			];
		},
		// coppie chiave/valore della card prodotto nel riepilogo del giorno (vista telefono)
		campiProdottoGiorno(product) {
			return [
				{ label: 'Prodotto', value: product.Title },
				{ label: 'SKU', value: product.SKU },
				{ label: 'N° Ordine Fornitore', value: product.orderSupplierId },
				{ label: 'Quantità', value: product.QuantityPurchased, strong: true },
				{ label: 'Rif. Ordine', value: product.OrderID },
			];
		},
		hasDateEvents(date) {
			return this.events.some(e => e.start === date);
		},
		viewDay({ date }) {
			const dayEvents = this.events.filter(e => e.start === date);
			if (dayEvents.length > 0) {
				this.selectedDayDate = date;
				this.selectedDayEvents = dayEvents;
				this.dialogDay = true;
			} else {
				this.focus = date;
				this.type = 'day';
			}
		},
		getEventColor(event) {
			return event.color;
		},
		setToday() {
			this.focus = '';
		},
		prev() {
			this.$refs.calendar.prev();
		},
		next() {
			this.$refs.calendar.next();
		},
		showEvent({ nativeEvent, event }) {
			const open = () => {
				this.selectedEvent = event;
				this.selectedElement = nativeEvent.target;
				requestAnimationFrame(() => requestAnimationFrame(() => (this.dialog = true)));
			};

			if (this.dialog) {
				this.dialog = false;
				requestAnimationFrame(() => requestAnimationFrame(() => open()));
			} else {
				open();
			}

			nativeEvent.stopPropagation();
		},
		updateRange({ start, end }) {
			const events = [];

			const min = new Date(`${start.date}T00:00:00`);
			const max = new Date(`${end.date}T23:59:59`);

			this.getSupplierOrders({ date_min: min, date_max: max }).then(fetchOrders => {
				for (let i = 0; i < fetchOrders.orders.length; i++) {
					for (let j = 0; j < fetchOrders.orders[i].orders.length; j++) {
						let order = fetchOrders.orders[i].orders[j];
						let date_split = order.order_date.split('T');
						events.push({
							name: `(${order.products.length}) ${order.supplier.Company}`,
							start: date_split[0],
							end: date_split[0],
							color: this.colors[this.rnd(0, this.colors.length - 1)],
							timed: false,
							details: order,
						});
					}
				}

				this.ordersVoid = fetchOrders.void;
				this.events = events;
			});
		},
		rnd(a, b) {
			return Math.floor((b - a + 1) * Math.random()) + a;
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},
		async createReportOrder(item) {
			var textToSave = `RIEPILOGO ORDINE \n\n Fornitore \n ${item.details.supplier.Company} \n\n Data Consegna Ordine \n ${new Date(item.start).toLocaleDateString()} \n \n Prodotti richiesti \n\n`;
			var textToSaveHtml = `RIEPILOGO ORDINE <br/><br/> Fornitore <br/> ${item.details.supplier.Company} <br/><br/> Data Consegna Ordine <br/> ${new Date(
				item.start,
			).toLocaleDateString()} <br/><br/> Prodotti richiesti <br/><br/>`;

			var itemsToWrite = [];

			_.forEach(item.details.products, prod => {
				if (prod.exclude != undefined && prod.exclude == true) {
				} else if (this.ordersVoid.includes(prod.OrderID)) {
					console.log(prod.OrderID);
				} else {
					var check = _.find(itemsToWrite, { sku: prod.SKU });
					if (!check) {
						itemsToWrite.push({
							sku: prod.SKU,
							title: prod.Title,
							qty: prod.QuantityPurchased,
							supplier_code: prod.supplier_code ? prod.supplier_code : 'n.d.',
						});
					} else {
						check.qty += prod.QuantityPurchased;
					}
				}
			});

			_.forEach(itemsToWrite, i => {
				textToSave += `Qtà ${i.qty} - ${i.title} - ${i.sku} ${i.supplier_code !== 'n.d.' ? `- Cod. Fornitore: ${i.supplier_code}` : ''}  \n\n`;
				textToSaveHtml += `Qtà ${i.qty} - ${i.title} - ${i.sku} ${i.supplier_code !== 'n.d.' ? `- Cod. Fornitore: ${i.supplier_code}` : ''} <br/><br/>`;
			});

			return { plain: textToSave, html: textToSaveHtml };
		},
		async downloadCsv(item) {
			var text = await this.createReportOrder(item);

			var today = new Date();
			var h = today.getHours();
			var m = today.getMinutes();
			var s = today.getSeconds();

			var now = h + '_' + m + '_' + s;

			var hiddenElement = document.createElement('a');

			hiddenElement.href = 'data:attachment/text,' + encodeURI(text.plain);
			hiddenElement.target = '_blank';
			hiddenElement.download = now + '_riepilogo_ordine_fornitore.txt';
			hiddenElement.click();
		},
		async sendMail(item) {
			this.loading_mail = true;
			var text = await this.createReportOrder(item);

			var payload = { plain: text.plain, html: text.html, supplier: item.details.supplier, _profile: item.details._profile };
			var response = await this.sendSupplierOrdersEmail(payload);
			if (response.result) {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Email inviata correttamente';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.loading_mail = false;
			} else {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore: controllare la mail del fornitore';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.loading_mail = false;
			}
		},
		async updateExclude(order_supplier_id, product_id, exclude) {
			this.setPreload(true);
			let payload = { order_supplier_id: order_supplier_id, product_id: product_id, exclude: exclude };
			let response = await this.excludeProductFromOrder(payload);
			if (response.result) {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Ordine in lavorazione aggiornato correttamente';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.setPreload(false);
			} else {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore: operazione non riuscita';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.setPreload(false);
			}
		},
		async rollbackOrder(order_customer_id) {
			this.dialogConfirmRollback = true;
			this.orderIdRollback = order_customer_id;
			console.log(this.$refs.calendar);
		},

		async executeRollbackOrder() {
			this.setPreload(true);
			let payload = { order_id: this.orderIdRollback };
			let response = await this.rollbackSuppliersOrder(payload);
			if (response.result) {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Ordini Annullati correttamente';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.setPreload(false);
				this.dialogConfirmRollback = false;

				setTimeout(() => {
					this.dialog = false;
					window.location.reload();
				}, 1000);
			} else {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore: operazione non riuscita';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.setPreload(false);
			}
		},
		async createReportOrderAll(dayEvents) {
			var textToSave = `RIEPILOGO ORDINI - ${new Date(this.selectedDayDate + 'T00:00:00').toLocaleDateString()} \n\n`;
			var textToSaveHtml = `RIEPILOGO ORDINI - ${new Date(this.selectedDayDate + 'T00:00:00').toLocaleDateString()} <br/><br/>`;

			var itemsToWrite = [];

			dayEvents.forEach(event => {
				_.forEach(event.details.products, prod => {
					if (prod.exclude || this.ordersVoid.includes(prod.OrderID)) return;

					var check = _.find(itemsToWrite, { sku: prod.SKU });
					if (!check) {
						itemsToWrite.push({
							sku: prod.SKU,
							title: prod.Title,
							qty: prod.QuantityPurchased,
							supplier_code: prod.supplier_code || 'n.d.',
							supplier: event.details.supplier.Company,
						});
					} else {
						check.qty += prod.QuantityPurchased;
					}
				});
			});

			_.forEach(itemsToWrite, i => {
				textToSave += `Fornitore: ${i.supplier} - Qtà ${i.qty} - ${i.title} - ${i.sku}${i.supplier_code !== 'n.d.' ? ` - Cod. Fornitore: ${i.supplier_code}` : ''} \n\n`;
				textToSaveHtml += `Fornitore: ${i.supplier} - Qtà ${i.qty} - ${i.title} - ${i.sku}${i.supplier_code !== 'n.d.' ? ` - Cod. Fornitore: ${i.supplier_code}` : ''} <br/><br/>`;
			});

			return { plain: textToSave, html: textToSaveHtml };
		},

		async downloadCsvAll() {
			var text = await this.createReportOrderAll(this.selectedDayEvents);
			var today = new Date();
			var now = today.getHours() + '_' + today.getMinutes() + '_' + today.getSeconds();
			var hiddenElement = document.createElement('a');
			hiddenElement.href = 'data:attachment/text,' + encodeURI(text.plain);
			hiddenElement.target = '_blank';
			hiddenElement.download = now + '_riepilogo_ordini_giorno.txt';
			hiddenElement.click();
		},

		async downloadExcelAll() {
			var rows = this.selectedDayProducts.map(product => ({
				Fornitore: product.supplierName,
				'N° Ordine Fornitore': product.orderSupplierId,
				'Nome Prodotto': `${product.Title} - SKU: ${product.SKU}`,
				Quantità: product.QuantityPurchased,
				'Rif.Ordine': product.OrderID,
			}));

			var worksheet = XLSX.utils.json_to_sheet(rows);
			var workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, 'Riepilogo');

			var today = new Date();
			var now = today.getHours() + '_' + today.getMinutes() + '_' + today.getSeconds();
			XLSX.writeFile(workbook, now + '_riepilogo_ordini_giorno.xlsx');
		},

		async sendMailAll() {
			this.loading_mail_all = true;
			var allOk = true;
			for (const event of this.selectedDayEvents) {
				var text = await this.createReportOrder(event);
				var payload = { plain: text.plain, html: text.html, supplier: event.details.supplier, _profile: event.details._profile };
				var response = await this.sendSupplierOrdersEmail(payload);
				if (!response.result) allOk = false;
			}
			this.snackbar.color = allOk ? 'success' : 'error';
			this.snackbar.text = allOk ? 'Email inviate correttamente' : 'Errore: controllare le mail dei fornitori';
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.loading_mail_all = false;
		},

		getKitDesc(products) {
			var desc = '';
			_.forEach(products, (prod, index) => {
				desc += prod.name + ' [' + prod.qt + ' qtà] ';
				if (index < products.length - 1) {
					desc += ' - ';
				}
			});
			return desc;
		},
	},
};
</script>

<style scoped>
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
.custom-loader {
	animation: loader 1s infinite;
	display: flex;
	color: #fff;
}
@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@-o-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
</style>
